/** Pevné ID interného marketing webu (migrácia 20260725110000). */
export const MARKETING_SITE_ANALYTICS_ID = "a0000000-0000-4000-8000-000000000001";

export const MARKETING_SITE_URL_PATTERN = /webnaprenajom\.sk/i;
